/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Tlm_3Inputs */

const en_svc_mvp_sprint_tlm_3 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`support`)
};

const ar_svc_mvp_sprint_tlm_3 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الدعم`)
};

const bn_svc_mvp_sprint_tlm_3 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সাপোর্ট`)
};

const de_svc_mvp_sprint_tlm_3 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const es_svc_mvp_sprint_tlm_3 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte`)
};

const fr_svc_mvp_sprint_tlm_3 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const pt_svc_mvp_sprint_tlm_3 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suporte`)
};

const zh_svc_mvp_sprint_tlm_3 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持`)
};

const tr_svc_mvp_sprint_tlm_3 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destek`)
};

const ru_svc_mvp_sprint_tlm_3 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддержка`)
};

const pl_svc_mvp_sprint_tlm_3 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wsparcie`)
};

/**
* | output |
* | --- |
* | "support" |
*
* @param {Svc_Mvp_Sprint_Tlm_3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_tlm_3 = /** @type {((inputs?: Svc_Mvp_Sprint_Tlm_3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Tlm_3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_tlm_3(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_tlm_3(inputs)
	if (locale === "de") return de_svc_mvp_sprint_tlm_3(inputs)
	if (locale === "es") return es_svc_mvp_sprint_tlm_3(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_tlm_3(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_tlm_3(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_tlm_3(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_tlm_3(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_tlm_3(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_tlm_3(inputs)
	return en_svc_mvp_sprint_tlm_3(inputs)
});
export { svc_mvp_sprint_tlm_3 as "svc_mvp-sprint_tlm_3" }